import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import Dummy from "components/Dummy";
import ShippingInfoRow from "./ShippingInfoRow";
import VerticalFlex from "layouts/flex/VerticalFlex";
import CustomPagination from "components/pagination/CustomPagination";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import MobileShippingInfoRow from "./MobileShippingInfoRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";

function ShippingInfoList(props) {
    const { t } = useTranslation();
    const { isMobile } = useContext(BrowserDetectContext);
    const { shippingInfos } = props;
    const navigate = useNavigate();
    const { products } = useSelector((state) => ({
        products: state.cart.products,
    }));
    const [shippingList, setShippingList] = useState([]);
    const { setIsAdd } = props;

    useEffect(() => {
        if (shippingInfos) {
            // 기본배송지를 최상단으로 정렬
            const sortedShippingList = [...shippingInfos].sort((a, b) => {
                // 기본배송지인 경우 metadata.default가 true
                const isDefaultA = a?.metadata?.default === true;
                const isDefaultB = b?.metadata?.default === true;

                if (isDefaultA && !isDefaultB) return -1; // a가 기본배송지면 위로
                if (!isDefaultA && isDefaultB) return 1;  // b가 기본배송지면 위로
                return 0; // 둘 다 기본배송지이거나 둘 다 아닌 경우 순서 유지
            });

            setShippingList(sortedShippingList);
        }
    }, [shippingInfos]);

    const shippingInfoCallback = (callback) => {
        setShippingList(callback);
    }

    const shippingInfoEditCallback = (value) => {
        if (value?.customer?.shipping_addresses) {
            const sortedList = [...value.customer.shipping_addresses].sort((a, b) => {
                const isDefaultA = a?.metadata?.default === true;
                const isDefaultB = b?.metadata?.default === true;
                if (isDefaultA && !isDefaultB) return -1;
                if (!isDefaultA && isDefaultB) return 1;
                return 0;
            });
            setShippingList(sortedList);
        }
    };
    const onShippingInfoAddClick = () => {
        isMobile ? (
            NiceModal.show("shippingInfoAddKrModal", {
                callback: addShippingInfoCallback,
                mode: "add",
                setAdd: setIsAdd,
            })
        ) : (
            NiceModal.show("shippingInfoAddModal", {
                callback: addShippingInfoCallback,
                setIsAdd: setIsAdd,
            })
        )
    }

    const addShippingInfoCallback = (value) => {
        setShippingList((prevShippingList) => {
            const newList = [...prevShippingList, value[0]];
            return newList.sort((a, b) => {
                const isDefaultA = a?.metadata?.default === true;
                const isDefaultB = b?.metadata?.default === true;
                if (isDefaultA && !isDefaultB) return -1;
                if (!isDefaultA && isDefaultB) return 1;
                return 0;
            });
        });
    };

    // ====== paging ======
    const itemsPerPage = 8;
    const [currentPage, setCurrentPage] = useState(1);
    const [currentData, setCurrentData] = useState([]);

    useEffect(() => {
        if (shippingList && shippingList.length > 0) {
            const startIndex = (currentPage - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            setCurrentData(shippingList.slice(startIndex, endIndex));
        }
    }, [currentPage, shippingList]);

    return (
        <FlexChild>
            {isMobile ? (
                <VerticalFlex>
                    <FlexChild width={"95%"} padding={"15px 5px"}>
                        <HorizontalFlex>
                            <FlexChild width={"max-content"} onClick={() => { navigate("/mypage") }}>
                                <FontAwesomeIcon fontSize={20} icon={fas["faAngleLeft"]} />
                            </FlexChild>
                            <FlexChild justifyContent={"center"}>
                                <P size={18} weight={700}> 배송지 등록 및 관리 </P>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        {currentData && currentData.length > 0 &&
                            currentData.map((row, index) => (
                                <MobileShippingInfoRow
                                    key={row.id}
                                    index={index}
                                    shippingInfo={row}
                                    shippingInfoCallback={shippingInfoCallback}
                                    shippingInfoEditCallback={shippingInfoEditCallback}
                                    setIsAdd={setIsAdd}
                                />
                            ))}
                    </FlexChild>
                    <FlexChild alignItems={"center"} padding={"0 0 0 0"} marginBottom={'20px'}>
                        <div
                            onClick={onShippingInfoAddClick}
                            style={{ maxWidth: "95%", border: 'none', padding: '10px', borderRadius: '3px', backgroundColor: "#f7f8f8", textAlign: "center" }}>
                            <p style={{ fontSize: '18px', color: 'var(--main-color)', fontWeight: 'bold' }}>
                                + 배송지 추가
                            </p>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            ) : (
                <VerticalFlex>
                    <FlexChild alignItems={"flex-end"} padding={"10px 0 0 0 "} marginBottom={'20px'}>
                        <button
                            onClick={onShippingInfoAddClick}
                            style={{ border: 'none', backgroundColor: 'white', padding: '5px 20px', border: "1px solid #296AFF", borderRadius: '3px', backgroundColor: '#296AFF' }}>
                            <p style={{ fontSize: '14px', color: 'white', fontWeight: 'bold' }}>
                                신규등록
                            </p>
                        </button>
                    </FlexChild>
                    <FlexChild>
                        <div style={{ display: 'flex', textAlign: 'center', backgroundColor: '#e7e7e7', height: '50px', alignItems: 'center', fontSize: '14px' }}>
                            {!isMobile &&
                                < div style={{ width: '25%' }} > 이름</div>
                            }
                            <div style={{ width: '80%' }}>주소</div>
                            {!isMobile &&
                                < div style={{ width: '30%' }}> 전화번호</div>
                            }
                            <div style={{ width: '20%' }}>관리</div>
                        </div>
                        {currentData && currentData.length > 0 &&
                            currentData.map((row, index) => (
                                <div style={{ borderBottom: ' 1px solid lightgray' }}>
                                    <ShippingInfoRow key={row.id} index={index} shippingInfo={row} shippingInfoCallback={shippingInfoCallback} shippingInfoEditCallback={shippingInfoEditCallback} setIsAdd={setIsAdd} />
                                </div>
                            ))}
                        <CustomPagination
                            currentPage={currentPage}
                            totalPages={shippingList && shippingList.length > 0 && Math.ceil(shippingList.length / itemsPerPage)}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                    </FlexChild>
                    <Dummy height={60} />
                </VerticalFlex >
            )}
        </FlexChild>
    );
}

export default ShippingInfoList;